export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9547.6930ef6c.jpg";